export enum SharingTipAction {
    ignore,
    refreshExpiration,
    changePermission,
    attachAsACopy,
}
